import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('blend');
const type = createActionType('blend');

export const INITIALIZE = type('Initialize');
export const INITIALIZE_CONFIG = type('InitializeConfig');
export const CHANGE_BLEND_TYPE = type('ChangeBlendType');
export const CHANGE_RIGHT_DATASET = type('ChangeRightDataset');
export const CHANGE_LEFT_DATASET = type('ChangeLeftDataset');
export const TOGGLE_DEDUPE_JOIN_KEYS = type('ToggleDedupeJoinKeys');
export const ADD_CRITERIA = type('AddCriteria');
export const REMOVE_CRITERIA = type('RemoveCriteria');
export const SAVE = type('Save');
export const SELECT_TAB = type('SelectTab');
export const REFRESH_TAB = type('RefreshTab');
export const SAVE_JOIN = type('SaveJoin');
export const CREATE_JOIN_VIEW = apiType('CreateJoinView');
export const UPDATE_JOIN_VIEW = apiType('UpdateJoinView');
export const CLOSE_JOIN_EDITOR = type('CloseJoineditor');
export const RELOAD_PREVIEW = type('ReloadPreview');
export const INITIATE_CLOSE_EDITOR = type('InitiateCloseEditor');
